var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useMemo, useState, useCallback } from "react";
import { useSelector } from "react-redux";
import otcDi from "../../../../mainDi/features/OTC/servicelocator";
import actions from "@redux/feature/Markets/NCD/actions/OrderBookActions";
import TransactionJourneyActions from "@redux/feature/Markets/NCD/actions/TransactionJourneyActions";
import { debounce } from "underscore";
import { removeEmptyObjects } from "@frameworks/NCD/Utils/removeEmptyObjects";
import { EBuySellFlag } from "@domains/features/Markets/OTC/entities/CashFlow";
import { ERefundType } from "@frameworks/NCD/Enum/OTC";
import { EHoldingTypeNCD } from "@frameworks/NCD/Constants/constant";
var useRefund = function (setModify) {
    var cActions = new actions();
    var cTransactionJourneyActions = new TransactionJourneyActions();
    var _a = __read(useState(false), 2), loader = _a[0], setLoader = _a[1];
    var _b = __read(useState(""), 2), amount = _b[0], setAmount = _b[1];
    var _c = __read(useState(""), 2), utrNumber = _c[0], setUtrNumber = _c[1];
    var _d = __read(useState(""), 2), toast = _d[0], setToast = _d[1];
    var _e = __read(useState(false), 2), isRefundInitiated = _e[0], setIsRefundInitiated = _e[1];
    var _f = __read(useState({ error: null, isOpen: false }), 2), errorData = _f[0], setErrorData = _f[1];
    var _g = __read(useState({ error: null, isOpen: false }), 2), errorDataUtr = _g[0], setErrorDataUtr = _g[1];
    var _h = useSelector(function (state) { return state.markets.Otc.orderBookReducer; }), isRefundReasonSelected = _h.isRefundReasonSelected, orderBookDetails = _h.orderBookDetails, selectedRefundReason = _h.selectedRefundReason, selectedRefundType = _h.selectedRefundType, suspenseFormData = _h.suspenseFormData;
    var subCategoryId = useSelector(function (state) { return state.markets.Otc.productBouquetReducer; }).subCategoryId;
    var _j = useSelector(function (state) { return state.markets.Otc.transactionJourneyReducer; }), paymentMode = _j.paymentMode, uploadDeclaration = _j.uploadDeclaration, bankCodeDetails = _j.bankCodeDetails;
    var onClickCancel = function () {
        cActions.updateIsRefundReasonSelected(false);
    };
    var onClickProceed = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (!isRefundReasonSelected) {
                onSubmitRefund();
            }
            else {
                cActions.updateIsRefundReasonSelected(false);
            }
            return [2 /*return*/];
        });
    }); };
    var onSubmitRefund = function () { return __awaiter(void 0, void 0, void 0, function () {
        var data, error_1;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, 3, 4]);
                    setLoader(true);
                    data = removeEmptyObjects({
                        order_id: (_a = orderBookDetails === null || orderBookDetails === void 0 ? void 0 : orderBookDetails.data) === null || _a === void 0 ? void 0 : _a.order_id,
                        utr_no: utrNumber,
                        amount: Number(amount),
                        refund_type: String(selectedRefundType === null || selectedRefundType === void 0 ? void 0 : selectedRefundType.id),
                        order_source: "web",
                    });
                    return [4 /*yield*/, otcDi.orderBook.refund(data)];
                case 1:
                    _b.sent();
                    return [3 /*break*/, 4];
                case 2:
                    error_1 = _b.sent();
                    console.error("Refund failed:", error_1);
                    return [3 /*break*/, 4];
                case 3:
                    setLoader(false);
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var onSubmitRefundSuspense = function () { return __awaiter(void 0, void 0, void 0, function () {
        var data, res, error_2;
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        return __generator(this, function (_m) {
            switch (_m.label) {
                case 0:
                    _m.trys.push([0, 4, 5, 6]);
                    setLoader(true);
                    data = removeEmptyObjects({
                        pan: (_a = suspenseFormData === null || suspenseFormData === void 0 ? void 0 : suspenseFormData.clientPan) === null || _a === void 0 ? void 0 : _a.pan,
                        order_id: (_b = orderBookDetails === null || orderBookDetails === void 0 ? void 0 : orderBookDetails.data) === null || _b === void 0 ? void 0 : _b.order_id,
                        bank_acc_no: suspenseFormData === null || suspenseFormData === void 0 ? void 0 : suspenseFormData.accountNumber,
                        bank_name: (_c = suspenseFormData === null || suspenseFormData === void 0 ? void 0 : suspenseFormData.bankName) === null || _c === void 0 ? void 0 : _c.label,
                        ifsc_code: suspenseFormData === null || suspenseFormData === void 0 ? void 0 : suspenseFormData.ifscCode,
                        utr_no: suspenseFormData === null || suspenseFormData === void 0 ? void 0 : suspenseFormData.utrOrChequeNo,
                        amount: suspenseFormData === null || suspenseFormData === void 0 ? void 0 : suspenseFormData.amount,
                        category_code: Number(subCategoryId),
                        order_source: "web",
                        refund_type: selectedRefundType === null || selectedRefundType === void 0 ? void 0 : selectedRefundType.id,
                    });
                    return [4 /*yield*/, otcDi.orderBook.suspenseRefund(data)];
                case 1:
                    res = _m.sent();
                    if (!(((_d = res === null || res === void 0 ? void 0 : res.data) === null || _d === void 0 ? void 0 : _d.status) === "Success")) return [3 /*break*/, 3];
                    return [4 /*yield*/, otcDi.orderBook.uploadSuspenseDoc({
                            refund_id: (_e = res === null || res === void 0 ? void 0 : res.data) === null || _e === void 0 ? void 0 : _e.refund_id,
                            file_data: (_h = (_g = (_f = suspenseFormData === null || suspenseFormData === void 0 ? void 0 : suspenseFormData.bankProof) === null || _f === void 0 ? void 0 : _f[0]) === null || _g === void 0 ? void 0 : _g.imageUrl) === null || _h === void 0 ? void 0 : _h.split(",")[1],
                            file_name: (_l = (_k = (_j = suspenseFormData === null || suspenseFormData === void 0 ? void 0 : suspenseFormData.bankProof) === null || _j === void 0 ? void 0 : _j[0]) === null || _k === void 0 ? void 0 : _k.file) === null || _l === void 0 ? void 0 : _l.name,
                        })];
                case 2:
                    _m.sent();
                    _m.label = 3;
                case 3: return [3 /*break*/, 6];
                case 4:
                    error_2 = _m.sent();
                    console.error("Suspense refund failed:", error_2);
                    return [3 /*break*/, 6];
                case 5:
                    setLoader(false);
                    return [7 /*endfinally*/];
                case 6: return [2 /*return*/];
            }
        });
    }); };
    var errorMessageAmount = useMemo(function () {
        var _a;
        return ((_a = errorData === null || errorData === void 0 ? void 0 : errorData.error) === null || _a === void 0 ? void 0 : _a.message) || "";
    }, [errorData]);
    var isInValidAmount = useMemo(function () {
        var _a;
        return ((_a = errorData === null || errorData === void 0 ? void 0 : errorData.error) === null || _a === void 0 ? void 0 : _a.status) === "Failed";
    }, [errorData]);
    var errorMessageUtrNumber = useMemo(function () {
        var _a;
        return ((_a = errorDataUtr === null || errorDataUtr === void 0 ? void 0 : errorDataUtr.error) === null || _a === void 0 ? void 0 : _a.message) || "";
    }, [errorDataUtr]);
    var isInValiUtrNumber = useMemo(function () {
        var _a;
        return ((_a = errorDataUtr === null || errorDataUtr === void 0 ? void 0 : errorDataUtr.error) === null || _a === void 0 ? void 0 : _a.status) === "Failed";
    }, [errorDataUtr]);
    var debouncedInputHandler = useCallback(debounce(function (inputValue) {
        validateInterest(inputValue, selectedRefundType === null || selectedRefundType === void 0 ? void 0 : selectedRefundType.id);
    }, 500), [orderBookDetails, selectedRefundType === null || selectedRefundType === void 0 ? void 0 : selectedRefundType.id]);
    var debouncedInputUtrHandler = useCallback(debounce(function (inputValue) {
        validateUtrNumber(inputValue);
    }, 500), [orderBookDetails]);
    var validateInterest = function (inputValue, id) { return __awaiter(void 0, void 0, void 0, function () {
        var res, error_3;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 2, 3, 4]);
                    return [4 /*yield*/, otcDi.orderBook.validateInterest({
                            order_id: (_a = orderBookDetails === null || orderBookDetails === void 0 ? void 0 : orderBookDetails.data) === null || _a === void 0 ? void 0 : _a.order_id,
                            interest_amount: Number(inputValue),
                            amount: Number((_b = orderBookDetails === null || orderBookDetails === void 0 ? void 0 : orderBookDetails.data) === null || _b === void 0 ? void 0 : _b.amount),
                            refund_type: id,
                        })];
                case 1:
                    res = _c.sent();
                    setErrorData({
                        error: res === null || res === void 0 ? void 0 : res.data,
                        isOpen: false,
                    });
                    return [3 /*break*/, 4];
                case 2:
                    error_3 = _c.sent();
                    setErrorData({
                        error: { status: "Failed", message: "Validation error" },
                        isOpen: true,
                    });
                    return [3 /*break*/, 4];
                case 3: return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var validateUtrNumber = function (inputValue) { return __awaiter(void 0, void 0, void 0, function () {
        var res, error_4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, 3, 4]);
                    return [4 /*yield*/, otcDi.orderBook.validateUTR({
                            urt_ref_no: String(inputValue),
                        })];
                case 1:
                    res = _a.sent();
                    setErrorDataUtr({
                        error: res === null || res === void 0 ? void 0 : res.data,
                        isOpen: false,
                    });
                    return [3 /*break*/, 4];
                case 2:
                    error_4 = _a.sent();
                    setErrorDataUtr({
                        error: { status: "Failed", message: "Validation error" },
                        isOpen: true,
                    });
                    return [3 /*break*/, 4];
                case 3: return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var handleChangeAmount = function (event) {
        var inputValue = event.target.value;
        setAmount(inputValue);
        debouncedInputHandler(inputValue);
    };
    var handleChangeUtrNumber = function (event) {
        var inputValue = event.target.value;
        setUtrNumber(inputValue);
        debouncedInputUtrHandler(inputValue);
    };
    var handleOrderbookFooterCTAClick = function (buttonType) { return __awaiter(void 0, void 0, void 0, function () {
        var res, error_5, res, error_6;
        var _a, _b, _c, _d, _e, _f, _g, _h;
        return __generator(this, function (_j) {
            switch (_j.label) {
                case 0:
                    if (!(((_a = orderBookDetails === null || orderBookDetails === void 0 ? void 0 : orderBookDetails.data) === null || _a === void 0 ? void 0 : _a.is_modify_cta) === buttonType)) return [3 /*break*/, 1];
                    setModify(true);
                    return [3 /*break*/, 11];
                case 1:
                    if (!(((_b = orderBookDetails === null || orderBookDetails === void 0 ? void 0 : orderBookDetails.data) === null || _b === void 0 ? void 0 : _b.txt_is_cta) === "Duplicate")) return [3 /*break*/, 7];
                    _j.label = 2;
                case 2:
                    _j.trys.push([2, 4, 5, 6]);
                    setLoader(true);
                    return [4 /*yield*/, otcDi.orderBook.duplicateOrder({
                            order_id: Number((_c = orderBookDetails === null || orderBookDetails === void 0 ? void 0 : orderBookDetails.data) === null || _c === void 0 ? void 0 : _c.order_id),
                            buy_sell_flag: (_d = orderBookDetails === null || orderBookDetails === void 0 ? void 0 : orderBookDetails.data) === null || _d === void 0 ? void 0 : _d.type.toUpperCase(),
                        })];
                case 3:
                    res = _j.sent();
                    setToast((_e = res === null || res === void 0 ? void 0 : res.data) === null || _e === void 0 ? void 0 : _e.message);
                    return [3 /*break*/, 6];
                case 4:
                    error_5 = _j.sent();
                    console.error("Refund failed:", error_5);
                    return [3 /*break*/, 6];
                case 5:
                    setLoader(false);
                    return [7 /*endfinally*/];
                case 6: return [3 /*break*/, 11];
                case 7:
                    _j.trys.push([7, 9, 10, 11]);
                    setLoader(true);
                    return [4 /*yield*/, otcDi.orderBook.getOrderBookResendConsent({
                            order_id: Number((_f = orderBookDetails === null || orderBookDetails === void 0 ? void 0 : orderBookDetails.data) === null || _f === void 0 ? void 0 : _f.order_id),
                            buy_sell_flag: (_g = orderBookDetails === null || orderBookDetails === void 0 ? void 0 : orderBookDetails.data) === null || _g === void 0 ? void 0 : _g.type.toUpperCase(),
                        })];
                case 8:
                    res = _j.sent();
                    setToast((_h = res === null || res === void 0 ? void 0 : res.data) === null || _h === void 0 ? void 0 : _h.message);
                    return [3 /*break*/, 11];
                case 9:
                    error_6 = _j.sent();
                    console.error("Refund failed:", error_6);
                    return [3 /*break*/, 11];
                case 10:
                    setLoader(false);
                    return [7 /*endfinally*/];
                case 11: return [2 /*return*/];
            }
        });
    }); };
    var handlePaymentModeSelection = function () { return __awaiter(void 0, void 0, void 0, function () {
        var res, res_1, updatedPayment, error_7;
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x;
        return __generator(this, function (_y) {
            switch (_y.label) {
                case 0:
                    _y.trys.push([0, 5, 6, 7]);
                    setLoader(true);
                    return [4 /*yield*/, otcDi.orderBook.updateModifyPaymentMode(removeEmptyObjects({
                            order_id: Number((_a = orderBookDetails === null || orderBookDetails === void 0 ? void 0 : orderBookDetails.data) === null || _a === void 0 ? void 0 : _a.order_id),
                            payment_mode: paymentMode === null || paymentMode === void 0 ? void 0 : paymentMode.type,
                            bank_acc_no: (_b = paymentMode === null || paymentMode === void 0 ? void 0 : paymentMode.bankName) === null || _b === void 0 ? void 0 : _b.bank_acc_no,
                            payment_ref_no: (paymentMode === null || paymentMode === void 0 ? void 0 : paymentMode.type) === EHoldingTypeNCD.NetBanking
                                ? ""
                                : (paymentMode === null || paymentMode === void 0 ? void 0 : paymentMode.type) === EHoldingTypeNCD.Cheque
                                    ? paymentMode === null || paymentMode === void 0 ? void 0 : paymentMode.chequeNo
                                    : paymentMode === null || paymentMode === void 0 ? void 0 : paymentMode.rtgsNo,
                            bank_code: (_d = (_c = bankCodeDetails === null || bankCodeDetails === void 0 ? void 0 : bankCodeDetails.data) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.bank_code,
                            existing_selected: ((_e = orderBookDetails === null || orderBookDetails === void 0 ? void 0 : orderBookDetails.data) === null || _e === void 0 ? void 0 : _e.payment_mode)
                                ? true
                                : false,
                            order_source: "web",
                        }))];
                case 1:
                    res = _y.sent();
                    if (!(((_g = (_f = res === null || res === void 0 ? void 0 : res.data) === null || _f === void 0 ? void 0 : _f.status) === null || _g === void 0 ? void 0 : _g.toLowerCase()) === "success" &&
                        (paymentMode === null || paymentMode === void 0 ? void 0 : paymentMode.type) !== EHoldingTypeNCD.NetBanking)) return [3 /*break*/, 4];
                    return [4 /*yield*/, otcDi.orderBook.updateModifyPaymentModeDoc({
                            order_id: Number((_h = orderBookDetails === null || orderBookDetails === void 0 ? void 0 : orderBookDetails.data) === null || _h === void 0 ? void 0 : _h.order_id),
                            file_data: (_k = (_j = uploadDeclaration === null || uploadDeclaration === void 0 ? void 0 : uploadDeclaration[0]) === null || _j === void 0 ? void 0 : _j.imageUrl) === null || _k === void 0 ? void 0 : _k.split(",")[1],
                            file_name: (_m = (_l = uploadDeclaration === null || uploadDeclaration === void 0 ? void 0 : uploadDeclaration[0]) === null || _l === void 0 ? void 0 : _l.file) === null || _m === void 0 ? void 0 : _m.name,
                            file_type: (_p = (_o = uploadDeclaration === null || uploadDeclaration === void 0 ? void 0 : uploadDeclaration[0]) === null || _o === void 0 ? void 0 : _o.imageUrl) === null || _p === void 0 ? void 0 : _p.split(",")[0],
                            pan: (_q = orderBookDetails === null || orderBookDetails === void 0 ? void 0 : orderBookDetails.data) === null || _q === void 0 ? void 0 : _q.pan,
                            buy_sell_flag: ((_r = orderBookDetails === null || orderBookDetails === void 0 ? void 0 : orderBookDetails.data) === null || _r === void 0 ? void 0 : _r.type) === EBuySellFlag.SELL.toLowerCase()
                                ? "S"
                                : ((_s = orderBookDetails === null || orderBookDetails === void 0 ? void 0 : orderBookDetails.data) === null || _s === void 0 ? void 0 : _s.type) === EBuySellFlag.BUY.toLowerCase()
                                    ? "B"
                                    : "R",
                        })];
                case 2:
                    res_1 = _y.sent();
                    setModify(false);
                    updatedPayment = __assign(__assign({}, paymentMode), { rtgsNo: "", chequeNo: "", bankName: { label: "", value: "", bank_acc_no: "", bank_code: "" } });
                    return [4 /*yield*/, otcDi.orderBook.getOrderBookDetails({
                            order_id: Number((_t = orderBookDetails === null || orderBookDetails === void 0 ? void 0 : orderBookDetails.data) === null || _t === void 0 ? void 0 : _t.order_id),
                            buy_sell_flag: (_v = (_u = orderBookDetails === null || orderBookDetails === void 0 ? void 0 : orderBookDetails.data) === null || _u === void 0 ? void 0 : _u.type) === null || _v === void 0 ? void 0 : _v.toUpperCase(),
                        })];
                case 3:
                    _y.sent();
                    cTransactionJourneyActions.updatePaymentModeValues(updatedPayment);
                    cTransactionJourneyActions.updateUploadDeclarationValueProp(null);
                    _y.label = 4;
                case 4:
                    setToast((_w = res === null || res === void 0 ? void 0 : res.data) === null || _w === void 0 ? void 0 : _w.message);
                    setErrorData({
                        error: null,
                        isOpen: false,
                    });
                    return [3 /*break*/, 7];
                case 5:
                    error_7 = _y.sent();
                    setErrorData({
                        error: (_x = error_7 === null || error_7 === void 0 ? void 0 : error_7.errorParams) === null || _x === void 0 ? void 0 : _x.data,
                        isOpen: true,
                    });
                    console.error("Refund failed:", error_7);
                    return [3 /*break*/, 7];
                case 6:
                    setLoader(false);
                    return [7 /*endfinally*/];
                case 7: return [2 /*return*/];
            }
        });
    }); };
    var isAmountInvalid = isInValidAmount || !amount;
    var isUtrInvalid = isInValiUtrNumber || !utrNumber;
    var buttonDisabled = useMemo(function () {
        if (isRefundReasonSelected)
            return false;
        var cancelledRejectedTypes = [
            ERefundType.CancelledRejected,
            3,
            9,
            14,
            19,
        ];
        if (cancelledRejectedTypes.includes(selectedRefundType === null || selectedRefundType === void 0 ? void 0 : selectedRefundType.id)) {
            return isAmountInvalid || isUtrInvalid;
        }
        return isAmountInvalid;
    }, [
        isRefundReasonSelected,
        selectedRefundReason === null || selectedRefundReason === void 0 ? void 0 : selectedRefundReason.id,
        isAmountInvalid,
        isUtrInvalid,
    ]);
    return {
        onClickCancel: onClickCancel,
        onClickProceed: onClickProceed,
        handleOrderbookFooterCTAClick: handleOrderbookFooterCTAClick,
        onSubmitRefundSuspense: onSubmitRefundSuspense,
        handleChangeAmount: handleChangeAmount,
        isRefundInitiated: isRefundInitiated,
        errorMessageAmount: errorMessageAmount,
        isInValidAmount: isInValidAmount,
        loader: loader,
        amount: amount,
        buttonDisabled: buttonDisabled,
        handleChangeUtrNumber: handleChangeUtrNumber,
        errorMessageUtrNumber: errorMessageUtrNumber,
        isInValiUtrNumber: isInValiUtrNumber,
        utrNumber: utrNumber,
        setAmount: setAmount,
        setUtrNumber: setUtrNumber,
        errorData: errorData,
        toast: toast,
        setToast: setToast,
        handlePaymentModeSelection: handlePaymentModeSelection,
        setErrorData: setErrorData,
    };
};
export default useRefund;
